import { profile } from 'api';

export type UpdateProfileRequest = {
  userId: string;
  name: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  birthDate: string;
  gender: 'Male' | 'Female';
  documentNumber: string;
  passportNumber: string;
  nationality: string;
};

export const updateProfile = (data: UpdateProfileRequest): Promise<void> =>
  profile.put('Users/UpdateUserForBooking', data);
